'use strict';

var _           = require('underscore');
var $           = require('jquery');
var Core        = require('../core/core.js');
var ToolbarTool = require('./toolbar__tool.js');
var ToolbarOffsetTool = require('./toolbar__offsettool.js');

/**
 * Creates a Tab Toolbar
 *
 * @class
 */

class Toolbar extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {}
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__tab__toolbar editor__tab__toolbar--left"></div>
        `;

        super.render();
    }

    /**
     * Adds a a tool to the toolbar of this tab
     */

    addTool(name, description, icon){
        return new ToolbarTool({
            target: this.$el,
            fields: {
                'name': name,
                'description': description,
                'icon': icon
            }
        })
    }

    addOffsetTool(name, description, icon){
        return new ToolbarOffsetTool({
            target: this.$el,
            fields: {
                'name': name,
                'description': description,
                'icon': icon
            }
        })
    }

    /**
     * Use expanded view of toolbar
     */

    makeExpanded(){
        this.$el.addClass("editor__tab__toolbar--expanded");
    }

}
module.exports = Toolbar;